var _path, _path2, _path3, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConvertIconDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48.514 18.434-7.8-7.8a2.175 2.175 0 0 0-1.526-.632h-16.69c-1.192 0-2.16.968-2.16 2.16v30.25c0 1.193.968 2.16 2.16 2.16h24.164c1.852 0 2.485-.896 2.485-2.16V19.96a2.147 2.147 0 0 0-.633-1.527Z",
    fill: "#0EC78A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.995 44.562c-.106.007-.217.01-.333.01H22.5a2.161 2.161 0 0 1-2.16-2.16v-30.25a2.161 2.161 0 0 0 0 0v30.25c0 1.192.967 2.16 2.16 2.16h24.163c.116 0 .227-.003.333-.01Zm4.21-2.15V19.963a4.209 4.209 0 0 0-1.238-2.987L42.17 9.18l-.006-.005a4.233 4.233 0 0 0-2.971-1.23H22.499a4.22 4.22 0 0 0-4.219 4.218v30.25A4.22 4.22 0 0 0 22.5 46.63h24.163c1.226 0 2.461-.296 3.378-1.195.925-.907 1.165-2.073 1.165-3.023Z",
    fill: "#0EC78A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.516 30.02-4.854-1.815a3.673 3.673 0 0 1-2.085-3.555 3.643 3.643 0 0 1 3.297-3.652.36.36 0 0 0 .304-.356v-.969a1.44 1.44 0 0 1 2.881 0v.9c0 .2.162.36.36.36h1.8a1.44 1.44 0 0 1 0 2.881h-4.5c-1.26 0-1.26.628-1.26.836-.024.317.07.63.263.881l4.854 1.815a3.673 3.673 0 0 1 2.084 3.563 3.642 3.642 0 0 1-3.297 3.644.36.36 0 0 0-.304.356v.97a1.44 1.44 0 0 1-2.88 0v-.901a.36.36 0 0 0-.36-.36h-1.801a1.441 1.441 0 0 1 0-2.881h4.501c1.26 0 1.26-.628 1.26-.836.023-.317-.07-.63-.263-.881Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.28,
    cy: 42.927,
    r: 10.698,
    fill: "#0EC78A",
    stroke: "#fff",
    strokeWidth: 0.818
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.922 48.124 6.59-4.565a.41.41 0 0 0 0-.672l-6.59-4.565a.41.41 0 0 0-.642.336v3.022h-4.63a1.543 1.543 0 1 0 0 3.086h4.63v3.022c0 .33.37.524.642.337Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIconDisabled);
export default __webpack_public_path__ + "static/media/convert-icon-disabled.9e6b52079739cdc944ddecd02f403f4a.svg";
export { ForwardRef as ReactComponent };